import { initTabs } from "../modules/tabs.js";
jQuery(($) => initTabs($));
